// extracted by mini-css-extract-plugin
export default {"holder":"Fireworks_holder__uPR4U"};